import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { searchFormItems } from './config';
import { PAGE_URL, updateLoginPermission } from '@/api/appletuser/appletuser';
import { toast } from '@/utils/message';
import { COMMON_ENABEL_STATUS } from '@/constant/system/code';
import { XTable } from '@/components/index';
import useStore from "@/store";

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Appletuser',
  setup(__props) {
    const tableInstance = ref();
    let searchData = {};
    const headerButton = [];
    function search(formDara) {
      searchData = formDara;
      tableInstance.value?.load(formDara);
    }
    function reset() {
      searchData = {};
      tableInstance.value?.load({});
    }
    function tableReLoad() {
      tableInstance.value?.load(searchData);
    }
    /**
     * 格式化性别显示
     * @param sexCode
     */
    function formatterSex(sexCode) {
      switch (sexCode) {
        case 'F':
          return '女';
        case 'M':
          return '男';
        default:
          return '未知';
      }
    }
    /**
     * 编辑登录许可权限
     */
    const loginPermissionEnable = computed(() => {
      if (useStore().user.actions.filter(item => item.authorityCode === 'manage:applet-user:updateLoginPermission').length > 0) {
        return false;
      } else {
        return true;
      }
    });
    /**
     * 修改登录许可状态
     * @param row
     */
    function handleUpdateLoginPermission(row) {
      updateLoginPermission({
        'id': row.id,
        'loginPermission': row.loginPermission
      }).then(() => {
        toast.success('操作成功');
        tableReLoad();
      });
    }
    return (_ctx, _cache) => {
      const _component_XSearchForm = _resolveComponent("XSearchForm");
      const _component_ElAvatar = _resolveComponent("ElAvatar");
      const _component_ElTableColumn = _resolveComponent("ElTableColumn");
      const _component_ElSwitch = _resolveComponent("ElSwitch");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createVNode(_component_XSearchForm, {
          ref: "searchForm",
          items: _unref(searchFormItems),
          onSearch: search,
          onReset: reset
        }, null, 8, ["items"]), _createVNode(_unref(XTable), {
          ref_key: "tableInstance",
          ref: tableInstance,
          url: _unref(PAGE_URL),
          "show-index": "",
          selectable: false,
          "header-buttons": headerButton,
          "el-table-props": {
            border: true
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_ElTableColumn, {
            label: "头像",
            prop: "avatarCode",
            align: "center",
            width: "80px"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_ElAvatar, {
              src: row.avatarCode,
              shape: "square",
              size: "small"
            }, null, 8, ["src"])]),
            _: 1
          }), _createVNode(_component_ElTableColumn, {
            label: "姓名",
            prop: "name",
            align: "center"
          }), _createVNode(_component_ElTableColumn, {
            label: "手机",
            prop: "telPhone",
            align: "center"
          }), _createVNode(_component_ElTableColumn, {
            label: "船号",
            prop: "shipNum",
            align: "center"
          }), _createVNode(_component_ElTableColumn, {
            label: "性别",
            prop: "sex",
            formatter: row => formatterSex(row.sex),
            align: "center"
          }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
            label: "登录许可",
            prop: "loginPermission",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_ElSwitch, {
              modelValue: row.loginPermission,
              "onUpdate:modelValue": $event => row.loginPermission = $event,
              disabled: _unref(loginPermissionEnable),
              "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
              "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE,
              onChange: $event => handleUpdateLoginPermission(row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "active-value", "inactive-value", "onChange"])]),
            _: 1
          }), _createVNode(_component_ElTableColumn, {
            label: "创建时间",
            prop: "createdAt",
            align: "center"
          })]),
          _: 1
        }, 8, ["url"])]),
        _: 1
      });
    };
  }
});